import { Center, Spinner } from '@chakra-ui/react';
import { useIntl } from 'react-intl';

import CockpitPanelHeader from '../CockpitPanelHeader';
import Panel from '../Panel';
import SensorDetail from './detail/SensorDetail';
import MonitoringList from './list/MonitoringList';
import { MonitoringProvider, useMonitoringContext } from './MonitoringContext';

const MonitoringPanelContent = () => {
  const { state, isSynchronizing } = useMonitoringContext();

  if (isSynchronizing) {
    return (
      <Center boxSize="100%">
        <Spinner boxSize="72px" />
      </Center>
    );
  }

  return state.selectedSensorKey === null ? <MonitoringList /> : <SensorDetail />;
};

export default function MonitoringPanel() {
  const { formatMessage } = useIntl();
  return (
    <Panel header={<CockpitPanelHeader label={formatMessage({ id: 'components.sidebar.MONITORING' })} />}>
      <MonitoringProvider>
        <MonitoringPanelContent />
      </MonitoringProvider>
    </Panel>
  );
}
